import {
  MorphingDialog,
  MorphingDialogClose,
  MorphingDialogContainer,
  MorphingDialogContent,
  MorphingDialogImage,
  MorphingDialogTrigger,
} from '@/components/ui/morphing-dialog';
import { getAnimatedVideoThumbnailUrl } from '@/lib/utils';
import { XIcon } from 'lucide-react';

export function PostFullView({ media, alt }: { media: { type: 'image' | 'video'; url: string }[], alt: string }) {
  console.log(media)
  return (
    <MorphingDialog
      transition={{
        duration: 0.3,
        ease: 'easeInOut',
      }}
    >
      <MorphingDialogTrigger>
        <MorphingDialogImage
          src={media[0].type === 'image' ? media[0].url : getAnimatedVideoThumbnailUrl(media[0].url)}
          alt={alt}
          className="object-cover"
        />
      </MorphingDialogTrigger>
      <MorphingDialogContainer>
        <MorphingDialogContent className="relative">
          <MorphingDialogImage
            src={media[0].type === 'image' ? media[0].url : getAnimatedVideoThumbnailUrl(media[0].url)}
            alt={alt}
            className="h-auto w-full max-w-[90vw] rounded-[4px] lg:h-[90vh]"
          />
        </MorphingDialogContent>
        <MorphingDialogClose
          className="fixed right-6 top-6 size-fit rounded-full bg-white p-1"
          variants={{
            initial: { opacity: 0 },
            animate: {
              opacity: 1,
              transition: { delay: 0.3, duration: 0.1 },
            },
            exit: { opacity: 0, transition: { duration: 0 } },
          }}
        >
          <XIcon className="size-5 text-zinc-500" />
        </MorphingDialogClose>
      </MorphingDialogContainer>
    </MorphingDialog>
  );
}
